import { links } from "./links";

import "./index.css";

export function Contactos() {
  return (
    <div className="d-flex justify-content-center align-items-center">
      {links.map((link, index) => (
        <a
          className="d-flex justify-content-center align-items-center me-3 fs-5 contact"
          key={index}
          href={link.href}
          target="_blank"
          rel="noreferrer"
          title={link.title}
        >
          <link.icon />
        </a>
      ))}
    </div>
  );
}
